"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";

import { ConfirmationBox } from "./components/confirmationFile/ConfirmContext";
import ServiceWorkerRegister from "./components/ServiceWorkerRegister";

export default function Providers({
    children,
}: {
    children: React.ReactNode;
}) {
    const [queryClient] = useState(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        retry: false,
                    },
                },
            })
    );

    return (
        <QueryClientProvider client={queryClient}>
            <ConfirmationBox>
                <ServiceWorkerRegister />
                {children}
            </ConfirmationBox>
        </QueryClientProvider>
    );
}